// tslint:disable
export enum HttpStatusCode {
    /**
     * @description Continue
     */
    Continue = 100,
    /**
     * @description SwitchingProtocols
     */
    SwitchingProtocols = 101,
    /**
     * @description OK
     */
    OK = 200,
    /**
     * @description Created
     */
    Created = 201,
    /**
     * @description Accepted
     */
    Accepted = 202,
    /**
     * @description NonAuthoritativeInformation
     */
    NonAuthoritativeInformation = 203,
    /**
     * @description NoContent
     */
    NoContent = 204,
    /**
     * @description ResetContent
     */
    ResetContent = 205,
    /**
     * @description PartialContent
     */
    PartialContent = 206,
    /**
     * @description MultipleChoices
     */
    MultipleChoices = 300,
    /**
     * @description Ambiguous
     */
    Ambiguous = 300,
    /**
     * @description MovedPermanently
     */
    MovedPermanently = 301,
    /**
     * @description Moved
     */
    Moved = 301,
    /**
     * @description Found
     */
    Found = 302,
    /**
     * @description Redirect
     */
    Redirect = 302,
    /**
     * @description SeeOther
     */
    SeeOther = 303,
    /**
     * @description RedirectMethod
     */
    RedirectMethod = 303,
    /**
     * @description NotModified
     */
    NotModified = 304,
    /**
     * @description UseProxy
     */
    UseProxy = 305,
    /**
     * @description Unused
     */
    Unused = 306,
    /**
     * @description TemporaryRedirect
     */
    TemporaryRedirect = 307,
    /**
     * @description RedirectKeepVerb
     */
    RedirectKeepVerb = 307,
    /**
     * @description BadRequest
     */
    BadRequest = 400,
    /**
     * @description Unauthorized
     */
    Unauthorized = 401,
    /**
     * @description PaymentRequired
     */
    PaymentRequired = 402,
    /**
     * @description Forbidden
     */
    Forbidden = 403,
    /**
     * @description NotFound
     */
    NotFound = 404,
    /**
     * @description MethodNotAllowed
     */
    MethodNotAllowed = 405,
    /**
     * @description NotAcceptable
     */
    NotAcceptable = 406,
    /**
     * @description ProxyAuthenticationRequired
     */
    ProxyAuthenticationRequired = 407,
    /**
     * @description RequestTimeout
     */
    RequestTimeout = 408,
    /**
     * @description Conflict
     */
    Conflict = 409,
    /**
     * @description Gone
     */
    Gone = 410,
    /**
     * @description LengthRequired
     */
    LengthRequired = 411,
    /**
     * @description PreconditionFailed
     */
    PreconditionFailed = 412,
    /**
     * @description RequestEntityTooLarge
     */
    RequestEntityTooLarge = 413,
    /**
     * @description RequestUriTooLong
     */
    RequestUriTooLong = 414,
    /**
     * @description UnsupportedMediaType
     */
    UnsupportedMediaType = 415,
    /**
     * @description RequestedRangeNotSatisfiable
     */
    RequestedRangeNotSatisfiable = 416,
    /**
     * @description ExpectationFailed
     */
    ExpectationFailed = 417,
    /**
     * @description UpgradeRequired
     */
    UpgradeRequired = 426,
    /**
     * @description InternalServerError
     */
    InternalServerError = 500,
    /**
     * @description NotImplemented
     */
    NotImplemented = 501,
    /**
     * @description BadGateway
     */
    BadGateway = 502,
    /**
     * @description ServiceUnavailable
     */
    ServiceUnavailable = 503,
    /**
     * @description GatewayTimeout
     */
    GatewayTimeout = 504,
    /**
     * @description HttpVersionNotSupported
     */
    HttpVersionNotSupported = 505,
}
(HttpStatusCode as any)['CONTINUE'] = 100;
(HttpStatusCode as any)['SWITCHINGPROTOCOLS'] = 101;
(HttpStatusCode as any)['CREATED'] = 201;
(HttpStatusCode as any)['ACCEPTED'] = 202;
(HttpStatusCode as any)['NONAUTHORITATIVEINFORMATION'] = 203;
(HttpStatusCode as any)['NOCONTENT'] = 204;
(HttpStatusCode as any)['RESETCONTENT'] = 205;
(HttpStatusCode as any)['PARTIALCONTENT'] = 206;
(HttpStatusCode as any)['MULTIPLECHOICES'] = 300;
(HttpStatusCode as any)['AMBIGUOUS'] = 300;
(HttpStatusCode as any)['MOVEDPERMANENTLY'] = 301;
(HttpStatusCode as any)['MOVED'] = 301;
(HttpStatusCode as any)['FOUND'] = 302;
(HttpStatusCode as any)['REDIRECT'] = 302;
(HttpStatusCode as any)['SEEOTHER'] = 303;
(HttpStatusCode as any)['REDIRECTMETHOD'] = 303;
(HttpStatusCode as any)['NOTMODIFIED'] = 304;
(HttpStatusCode as any)['USEPROXY'] = 305;
(HttpStatusCode as any)['UNUSED'] = 306;
(HttpStatusCode as any)['TEMPORARYREDIRECT'] = 307;
(HttpStatusCode as any)['REDIRECTKEEPVERB'] = 307;
(HttpStatusCode as any)['BADREQUEST'] = 400;
(HttpStatusCode as any)['UNAUTHORIZED'] = 401;
(HttpStatusCode as any)['PAYMENTREQUIRED'] = 402;
(HttpStatusCode as any)['FORBIDDEN'] = 403;
(HttpStatusCode as any)['NOTFOUND'] = 404;
(HttpStatusCode as any)['METHODNOTALLOWED'] = 405;
(HttpStatusCode as any)['NOTACCEPTABLE'] = 406;
(HttpStatusCode as any)['PROXYAUTHENTICATIONREQUIRED'] = 407;
(HttpStatusCode as any)['REQUESTTIMEOUT'] = 408;
(HttpStatusCode as any)['CONFLICT'] = 409;
(HttpStatusCode as any)['GONE'] = 410;
(HttpStatusCode as any)['LENGTHREQUIRED'] = 411;
(HttpStatusCode as any)['PRECONDITIONFAILED'] = 412;
(HttpStatusCode as any)['REQUESTENTITYTOOLARGE'] = 413;
(HttpStatusCode as any)['REQUESTURITOOLONG'] = 414;
(HttpStatusCode as any)['UNSUPPORTEDMEDIATYPE'] = 415;
(HttpStatusCode as any)['REQUESTEDRANGENOTSATISFIABLE'] = 416;
(HttpStatusCode as any)['EXPECTATIONFAILED'] = 417;
(HttpStatusCode as any)['UPGRADEREQUIRED'] = 426;
(HttpStatusCode as any)['INTERNALSERVERERROR'] = 500;
(HttpStatusCode as any)['NOTIMPLEMENTED'] = 501;
(HttpStatusCode as any)['BADGATEWAY'] = 502;
(HttpStatusCode as any)['SERVICEUNAVAILABLE'] = 503;
(HttpStatusCode as any)['GATEWAYTIMEOUT'] = 504;
(HttpStatusCode as any)['HTTPVERSIONNOTSUPPORTED'] = 505;
